import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { getFrontEnv, themeColor } from 'admin/utils';
import { ConnectedRouter } from 'connected-react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5';
import './app.global.scss';
import Routes from './routes';
import { history, store } from './store/configureStore';
import { theme } from './theme';

const env = getFrontEnv();

if (env && env !== 'local') {
  Sentry.init({
    dsn: 'https://54d0adb050f141f2bd7468f02cd2c208@o248495.ingest.sentry.io/6240327',
    integration: [new BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: env,
    release: RELEASE_VERSION,
    ignoreErrors: [
      'TypeError: Failed to fetch',
      'TypeError: NetworkError when attempting to fetch resource.',
      'TypeError: キャンセルしました',
      'TypeError: cancelled',
      'Error: Redirected due to authorization',
      'Error: Bad Gateway',
      'Error: Gateway Timeout',
      'Error: Server Error',
    ],
  });
}

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: themeColor.primaryColor,
    primary2Color: themeColor.primaryColor,
    pickerHeaderColor: themeColor.primaryColor,
  },
  button: {
    height: 40,
  },
});

render(
  <MuiThemeProvider muiTheme={muiTheme}>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <QueryParamProvider
            adapter={ReactRouter5Adapter}
            options={{
              removeDefaultsFromUrl: true,
            }}
          >
            <Routes />
          </QueryParamProvider>
        </ConnectedRouter>
      </Provider>
    </ThemeProvider>
  </MuiThemeProvider>,
  document.getElementById('root')
);
